module.exports = __webpack_public_path__ + "static/img/Nettroncode.e0529881.png";